import firebase from '../../../config/firebase';

const database = firebase.database();

// get Articles from firebase database/articles
export function getArticles (callback) {

   database.ref('articles').once('value')
     .then((snapshot) => {
       const articles = snapshot.val();
       callback(true, articles, null);
     }).catch(error=>{console.log(error)});
 }

// create a brand new Article
export function createNewArticle (data, callback) {
  // create new id
  var newId = database.ref().child('articles').push().key;
  // set the id on the data
  data["id"] = newId;
  // set in database
  database.ref('articles/' + newId).set(data, function(error) {
    if (error) {
      callback(false, null, error);
    } else {
      callback(true, data, null);
    }
  })
}

// edit an existing Article
export function editArticle (id, data, callback) {
  database.ref('articles/' + id).set(data, function(error) {
    if (error) {
      callback(false, null, error);
    } else {
      callback(true, data, null);
    }
  });
}

// delete an existing Article
export function deleteArticle(id, callback) {
  database.ref('articles').child(id).remove(function(error) {
    if (error) {
      callback(false, null, error);
    } else {
      callback(true, id, null);
    }
  });
}

// retrieve Settings containing Links and Shortcuts
export function getSettings (callback) {
  database.ref('settings').once('value')
    .then((snapshot) => {
      callback(snapshot.val() || {})
    }
  )
}

// create a brand new Link
export function createNewLink (data, callback) {
  var newId = database.ref('settings').child('links').push().key;
  data["id"] = newId;

  database.ref('settings/links/' + newId).set(data, function(error) {
    if (error) {
      callback(false, null, error);
    } else {
      callback(true, data, null);
    }
  })
}

// edit an existing Link
export function editLink (id, data, callback) {
  database.ref('settings/links/' + id).set(data, function(error) {
    if (error) {
      callback(false, null, error);
    } else {
      callback(true, data, null);
    }
  });
}

// delete an existing Link
export function deleteLink(id, callback) {
  database.ref('settings').child('links').child(id).remove(function(error) {
    if (error) {
      callback(false, null, error);
    } else {
      callback(true, id, null);
    }
  });
}

// create a brand new Shortcut
export function createNewShortcut (data, callback) {
  var newId = database.ref('settings').child('shortcuts').push().key;
  data["id"] = newId;

  database.ref('settings/shortcuts/' + newId).set(data, function(error) {
    if (error) {
      callback(false, null, error);
    } else {
      callback(true, data, null);
    }
  })
}

// edit an existing Shortcut
export function editShortcut (id, data, callback) {
  database.ref('settings/shortcuts/' + id).set(data, function(error) {
    if (error) {
      callback(false, null, error);
    } else {
      callback(true, data, null);
    }
  });
}

// delete an existing Shortcut
export function deleteShortcut(id, callback) {
  database.ref('settings').child('shortcuts').child(id).remove(function(error) {
    if (error) {
      callback(false, null, error);
    } else {
      callback(true, id, null);
    }
  });
}
